import { Component, OnInit } from '@angular/core';
import { FormsService } from 'src/app/services/forms/forms.service';
import { MasterListModel } from 'src/app/services/forms/master-list-model';
import { MessageService } from 'src/app/services/message.service';
import { ModuleListModel } from 'src/app/services/module/master-list-model';
import { ModuleService } from 'src/app/services/module/module.service';
import { SubmenuService } from '../submenu/submenu.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.less']
})
export class DashboardComponent implements OnInit {

  page:number = 1;
  componentData: ModuleListModel | undefined;
  
  constructor(public service: ModuleService, public messageService:MessageService, public submenuService:SubmenuService) 
  { 
    
  }

  ngOnInit(): void {
    
    this.messageService.showLoading();
    this.service.loadModuleList(this.page).subscribe((data:ModuleListModel) => {
        this.componentData = data;
        this.messageService.hideLoading();
    },    
    err => {
      this.messageService.hideLoading();
      this.messageService.showMessage(err.message, "error");
      console.log(err);
    });
  }

  ngAfterViewChecked(){
   
  }
}
